const initialState = {
  loginResult: null,
};

const ACTION_HANDLERS = {
  GET_RESULT_LOGIN: (state, action) =>
    Object.assign({}, state, { loginResult: action.loginResult }),
};

export default function loginRedirect(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
